import React, { useEffect, useState } from "react";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faXTwitter,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import {
  Form,
  InputGroup,
  Nav,
  Navbar,
  Offcanvas,
  Dropdown,
} from "react-bootstrap";
import {
  faBagShopping,
  faBars,
  faBell,
  faBoxOpen,
  faCartShopping,
  faHeart,
  faMagnifyingGlass,
  faPhone,
  faRightFromBracket,
  faShieldHalved,
  faSortDown,
  faUser,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Login_Modal from "../common_components/common_modal/login_modal/Login_Modal";
import Reset_Password_Modal from "../common_components/common_modal/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../common_components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Use_Current_Location from "../common_components/common_modal/Use_Current_Location/Use_Current_Location";
import Delete_Contact_Modal from "../common_components/common_modal/delete_contact_modal/Delete_Contact_Modal";
import { getAllCart, postToLoginCart } from "../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import { getNotifications } from "../../features/notifications/notificationSlice";
import { getLocationFromSession } from "../../features/location/locationSlice";
import Cookies from "js-cookie";
import {
  appSetup,
  getAllCategories,
  getAllChildCategory,
  getAllSubCategory,
} from "../../features/master/masterSlice";
import { PostSearchHistory } from "../../features/products/productsSlice";

function Header() {
  const [showCategory, setShowCategory] = useState(false);

  const [openMega, setOpenMega] = useState(false);
  const [openMain, setOpenMain] = useState(null);
  const [openSub, setOpenSub] = useState(null);

  const categories = [
    {
      title: "Electricals",
      subCategories: [
        { sub: "LED Lighting", items: ["Bulbs", "Tube Lights", "Spot Lights"] },
        { sub: "Lamps", items: ["Desk Lamps", "Bedside Lamps"] },
        { sub: "Focus Lights", items: ["Indoor Focus", "Outdoor Focus"] },
      ],
    },
    {
      title: "Hardware Items",
      subCategories: [
        { sub: "Handles", items: ["Door Handles", "Drawer Handles"] },
        { sub: "Locks", items: ["Main Locks", "Smart Locks"] },
      ],
    },
    {
      title: "Paints",
      subCategories: [
        { sub: "Interior Paints", items: ["Matt Finish", "Gloss Finish"] },
        { sub: "Exterior Paints", items: ["Weather Coat", "Primer"] },
      ],
    },
  ];

  useEffect(() => {
    const handleClickOutside = () => {
      setOpenMega(false);
      setShowCategory(false);
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState();
  // ✅ get search value from URL on load
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");

  const [searchTerm, setSearchTerm] = useState(searchValue || "");
  const [isLogedIn, setIsLogedIn] = useState(false);
  const [showLogoutModal, setshowLogoutModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [contact, setContact] = useState();
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  const notifications = useSelector(
    (state) => state.notification.notifications
  );
  const app_setup = useSelector((state) => state.master.app_setup);
  const current_location = useSelector(
    (state) => state.location.current_location
  );
  const socialLink = useSelector((state) => state.socialmedia.addSocialmedia);

  const navLinks = [
    { path: "/", label: "Home" },
    // { path: "/shop", label: "Shop" },
    { path: "/blog", label: "Blog" },
    { path: "/contact-us", label: "Contact Us" },
    // { path: "/career", label: "Career" },
  ];

  const isActive = (path) => currentPath === path;

  useEffect(() => {
    if (!location.search.includes("search=")) {
      setSearchTerm("");
    }
  }, [location.pathname, location.search]);

  // Wishlist & notifications
  useEffect(() => {
    dispatch(getAllWishlist());
  }, [dispatch]);

  useEffect(() => {
    if (isSignIn) {
      dispatch(getNotifications());
    }
  }, [isSignIn, dispatch]);

  useEffect(() => {
    const loginCart = async () => {
      if (isSignIn) {
        await dispatch(postToLoginCart());
      }
      await dispatch(getAllCart(isSignIn));
    };
    loginCart();
  }, [isSignIn, dispatch]);

  // location
  useEffect(() => {
    dispatch(getLocationFromSession());
  }, [dispatch]);

  useEffect(() => {
    const current_location = Cookies.get("current_location_grocido");
    if (!current_location) {
      setModalShow(true);
    }
  }, []);

  // app setup
  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  // ✅ search handlers
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && searchTerm.trim() !== "") {
      navigate(
        `/all-product?search=${encodeURIComponent(searchTerm)}`
      );
      dispatch(PostSearchHistory({ name: searchTerm }));
    }
  };

  const handleSearchClick = async () => {
    if (searchTerm.trim() !== "") {
      navigate(
        `/all-product?search=${encodeURIComponent(searchTerm)}`
      );
      await dispatch(PostSearchHistory({ name: searchTerm }));
    }
  };

  const goToNotificationsTab = () => {
    navigate("/my-profile", { state: { selectedTab: "third" } });
  };
  const [selectedCategory, setSelectedCategory] = useState(0);

  const categoriesData = useSelector((state) => state.master.categories);
  const subcategoriesData = useSelector((state) => state.master.subcategories);
  const childcategoriesData = useSelector(
    (state) => state.master.childcategories
  );
  useEffect(() => {
    dispatch(getAllCategories());

    // dispatch(getAllSubCategory());
  }, [dispatch]);

  useEffect(() => {
    if (categoriesData?.length > 0) {
      setSelectedCategory(categoriesData[0]?.id);

      dispatch(getAllSubCategory({ category_id: categoriesData[0]?.id }));
    }
  }, [categoriesData]);
  const handleClickCategory = async (category_id) => {
    setSelectedCategory(category_id);
    await dispatch(getAllSubCategory({ category_id }));
  };
  // useEffect(() => {
  //   if (subcategory_id) {
  //     dispatch(getAllSubCategory(subcategory_id));
  //   }
  // }, [subcategory_id]);

  const handleNavigate = (path) => {
    navigate(path);
    setOpenMega(false); // <-- CLOSE ON CLICK
  };
  return (
    <>
      <section className="Header">
        {/* Top header */}
        <div className="top_headers_holder">
          <div className="top_header">
            <div className="container">
              <div className="top_header_bar thnk_col_2">
                <div className="top_header_col1">
                  <div className="content_html">WELCOME TO DPORT</div>
                </div>
                <div className="top_header_col2">
                  <div className="content_social">
                    <ul className="social_icon">
                      {socialLink?.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => window.open(item?.url, "_blank")}
                        >
                          <img
                            src={process.env.REACT_APP_IMG_URL + item?.image}
                            className="icons"
                            alt="social"
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Middle header */}
          <div className="middle_header">
            <div className="container">
              <div className="all_divs_holder">
                {/* Logo */}
                <div className="logo_div" onClick={() => navigate("/")}>
                  <img
                    src="/assets/images/header/header_logo2.png"
                    className="logo_img"
                    alt="logo"
                  />
                </div>

                {/* Search box */}
                <div className="search_input_div">
                  <InputGroup>
                    <Form.Control
                      placeholder="Search Product"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={handleKeyPress}
                    />
                    <InputGroup.Text
                      onClick={handleSearchClick}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        className="search_icon"
                      />
                    </InputGroup.Text>
                  </InputGroup>
                </div>

                {/* Right side icons */}
                <div className="three_box_div ">
                  <div
                    className="box_div address_box"
                    onClick={() => setModalShow(true)}
                  >
                    <p className="title_text">
                      My Location{" "}
                      <FontAwesomeIcon
                        icon={faSortDown}
                        className="inner_icon"
                      />
                    </p>
                    <p className="sub_text">
                      <span className="title_span address_text">
                        {current_location?.formatted_address}
                      </span>
                    </p>
                  </div>

                  {/* Cart & account */}
                  {!isSignIn ? (
                    <>
                      <div className="box_div border_box">
                        <p className="title_text">My Cart</p>
                        <p
                          className="sub_text"
                          onClick={() => navigate("/cart")}
                        >
                          <FontAwesomeIcon
                            icon={faCartShopping}
                            className={`common_icon ${
                              currentPath === "/cart" ? "active" : ""
                            }`}
                          />
                        </p>
                      </div>
                      <div className="box_div border_box login_box">
                        <p className="title_text">Login / Signup</p>
                        <p
                          className="sub_text"
                          onClick={() => setShowLoginModal(true)}
                        >
                          <FontAwesomeIcon
                            icon={faUser}
                            className="common_icon"
                          />
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="box_div border_box">
                        <p className="title_text">My Cart</p>
                        <p
                          className="sub_text"
                          onClick={() => navigate("/cart")}
                        >
                          <FontAwesomeIcon
                            icon={faCartShopping}
                            className={`common_icon ${
                              currentPath === "/cart" ? "active" : ""
                            }`}
                          />
                        </p>
                      </div>

                      <div className="box_div">
                        <p className="title_text">My Favourite</p>
                        <p
                          className="sub_text"
                          onClick={() => navigate("/wishlist")}
                        >
                          <FontAwesomeIcon
                            icon={faHeart}
                            className={`common_icon ${
                              currentPath === "/wishlist" ? "active" : ""
                            }`}
                          />
                          {allWishlist?.data?.length || 0}
                        </p>
                      </div>

                      <div className="box_div">
                        <p className="title_text">Notification</p>
                        <p
                          className={`sub_text ${
                            notifications?.length > 0 ? "bell_icon_holder" : ""
                          }`}
                          onClick={goToNotificationsTab}
                        >
                          <FontAwesomeIcon
                            icon={faBell}
                            className="common_icon"
                          />
                          {notifications?.length > 0 && notifications?.length}
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom header */}
        <div className="bottom_header">
          <div className="container">
            <div className="two_box_holder">
              <div className="box1">
                <Navbar expand="lg">
                  {/* <div className="menu_toggle">
                    <button >
                      <FontAwesomeIcon icon={faBars} className="menu_icon" />{" "}
                      MENU
                    </button>
                  </div> */}

                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                      {navLinks.map((link) => (
                        <Nav.Link
                          key={link.path}
                          as={Link}
                          to={link.path}
                          active={isActive(link.path)}
                        >
                          {link.label}
                        </Nav.Link>
                      ))}

                      {/* Category Toggle Button */}
                      <Nav.Link
                        className="category_toggle_btn"
                        onClick={() => setShowCategory(!showCategory)}
                      >
                        Categories
                      </Nav.Link>

                      {/* Mega Menu Trigger */}
                      <div
                        className="mega_menu_main"
                        onMouseEnter={() => setOpenMega(true)}
                        onMouseLeave={() => setOpenMega(false)}
                        onClick={(e) => e.stopPropagation()} // <--- prevents auto-close
                      >
                        <Nav.Link className="categories_btn">
                          Categories
                        </Nav.Link>

                        {openMega && (
                          <div className="mega_dropdown">
                            <div className="row">
                              <div className="col-3">
                                <div className="mega_left_panel">
                                  {categoriesData?.map((val) => (
                                    <p
                                      key={val?.id}
                                      className={`left_item ${
                                        selectedCategory === val?.id
                                          ? "active"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        handleClickCategory(val?.id)
                                      }
                                    >
                                      {val?.name}
                                    </p>
                                  ))}

                                  {/* <p
                                    className="left_item"
                                    onClick={() => {
                                      navigate("/shop");
                                    }}
                                  >
                                    Hardware Items
                                  </p>
                                  <p
                                    className="left_item"
                                    onClick={() => {
                                      navigate("/shop");
                                    }}
                                  >
                                    Pipes & Fittings
                                  </p>
                                  <p
                                    className="left_item"
                                    onClick={() => {
                                      navigate("/shop");
                                    }}
                                  >
                                    Paints
                                  </p> */}
                                </div>
                              </div>

                              <div className="col-9">
                                <div className="mega_right_panel">
                                  <div className="row">
                                    {subcategoriesData?.map((val) => (
                                      <div className="col-4">
                                        <div className="mega_col">
                                          <h5>{val?.name}</h5>
                                          {val?.p_child_categories?.map(
                                            (val1) => (
                                              <p
                                                onClick={() => {
                                                  handleNavigate(
                                                    `/product-listing-child-category/${
                                                      val1?.id
                                                    }?sub_category_id=${
                                                      val?.id
                                                    }&category_name=${encodeURIComponent(
                                                      val?.p_category?.name
                                                    )}&subcategory_name=${encodeURIComponent(
                                                      val?.name
                                                    )}&category_image=${encodeURIComponent(
                                                      val?.image
                                                    )}`
                                                  );
                                                }}
                                              >
                                                {val1?.name}
                                              </p>
                                            )
                                          )}
                                          {/* <p
                                            onClick={() => {
                                              navigate("/shop");
                                              setOpenMega(false); // <--- CLOSE ON CLICK
                                            }}
                                          >
                                            Focus Lights
                                          </p>
                                          <p
                                            onClick={() => {
                                              navigate("/shop");
                                              setOpenMega(false); // <--- CLOSE ON CLICK
                                            }}
                                          >
                                            Lamps
                                          </p>
                                          <p
                                            onClick={() => {
                                              navigate("/shop");
                                              setOpenMega(false); // <--- CLOSE ON CLICK
                                            }}
                                          >
                                            Tube Lights
                                          </p>
                                          <p
                                            onClick={() => {
                                              navigate("/shop");
                                              setOpenMega(false); // <--- CLOSE ON CLICK
                                            }}
                                          >
                                            Reflectors
                                          </p>
                                          <p
                                            onClick={() => {
                                              navigate("/shop");
                                              setOpenMega(false); // <--- CLOSE ON CLICK
                                            }}
                                          >
                                            Ceiling Lights
                                          </p> */}
                                        </div>
                                      </div>
                                    ))}
                                    {/* <div className="col-4">
                                      <div className="mega_col">
                                        <h5>Switches & Sockets</h5>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Switch Board Plate
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Electrical Socket
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Communication Socket
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Modular Surface Box
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Lamp Holder
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-4">
                                      <div className="mega_col">
                                        <h5>Circuit Breakers</h5>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          MCB
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          RCCB
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          ACCL
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Isolator
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-4">
                                      <div className="mega_col">
                                        <h5>Wires & Cables</h5>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Low Tension Wire
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          LAN Cable
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          CCTV Cable
                                        </p>
                                      </div>
                                    </div>

                                    <div className="col-4">
                                      <div className="mega_col">
                                        <h5>Tools & Accessories</h5>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Accessory
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Door Bell
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Multi Plug Adaptor
                                        </p>
                                        <p
                                          onClick={() => {
                                            navigate("/shop");
                                            setOpenMega(false); // <--- CLOSE ON CLICK
                                          }}
                                        >
                                          Spike Guard
                                        </p>
                                      </div>
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* When click Categories → show accordion menu */}
                      {!showCategory && (
                        <div className="accordians_hodler">
                          {categories.map((cat, i) => (
                            <div
                              key={i}
                              className={`main_block ${
                                openMain === i ? "active" : ""
                              }`}
                            >
                              {/* MAIN ACCORDION HEADER */}
                              <div
                                className="main_header"
                                onClick={() => {
                                  setOpenMain(openMain === i ? null : i);
                                  setOpenSub(null);
                                }}
                              >
                                {cat.title}
                                <i
                                  className={`fa fa-chevron-down ${
                                    openMain === i ? "rotate" : ""
                                  }`}
                                ></i>
                              </div>

                              {/* MAIN ACCORDION CONTENT */}
                              {openMain === i && (
                                <div className="main_content">
                                  {cat.subCategories.map((sub, j) => (
                                    <div key={j} className="sub_block">
                                      {/* SUB CATEGORY HEADER */}
                                      <div
                                        className="sub_header"
                                        onClick={() =>
                                          setOpenSub(openSub === j ? null : j)
                                        }
                                      >
                                        {sub.sub}
                                        <i
                                          className={`fa fa-chevron-right ${
                                            openSub === j ? "rotate-right" : ""
                                          }`}
                                        ></i>
                                      </div>

                                      {/* INNER ITEMS */}
                                      {openSub === j && (
                                        <ul className="sub_items">
                                          {sub.items.map((item, k) => (
                                            <li
                                              key={k}
                                              onClick={() => {
                                                navigate("/shop");
                                              }}
                                            >
                                              {item}
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </div>

              <div className="box2">
                <div className="common_icon_holder">
                  <FontAwesomeIcon icon={faPhone} className="call_icon" />
                </div>
                <div className="text_holder">
                  <p className="first_text">Call To</p>
                  <p className="number_text">+91 {app_setup?.contact_no}</p>
                </div>

                {isSignIn && (
                  <Dropdown align="end" className="profile_dropdown">
                    <Dropdown.Toggle
                      variant="link"
                      bsPrefix="p-0 border-0 bg-transparent"
                    >
                      <div className="common_icon_holder profile_icon_holder">
                        <FontAwesomeIcon icon={faUser} className="call_icon" />
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="/my-profile">
                        <FontAwesomeIcon icon={faUser} className="icon" />{" "}
                        Profile
                      </Dropdown.Item>
                      <Dropdown.Item href="/my-orders">
                        <FontAwesomeIcon icon={faBoxOpen} className="icon" /> My
                        Orders
                      </Dropdown.Item>
                      <Dropdown.Item href="/change-password">
                        <FontAwesomeIcon
                          icon={faShieldHalved}
                          className="icon"
                        />{" "}
                        Change Password
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="logout_item"
                        onClick={() => {
                          setIsLogedIn(false);
                          setshowLogoutModal(true);
                          navigate("/");
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faRightFromBracket}
                          className="icon"
                        />{" "}
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Offcanvas */}
        <Offcanvas show={false} onHide={() => {}} className="menu_offcanvas">
          <Offcanvas.Header closeButton />
          <Offcanvas.Body>
            <Navbar expand="lg">
              <Nav className="me-auto">
                {navLinks.map((link) => (
                  <Nav.Link
                    key={link.path}
                    as={Link}
                    to={link.path}
                    active={isActive(link.path)}
                  >
                    {link.label}
                  </Nav.Link>
                ))}
              </Nav>
            </Navbar>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Modals */}
        <Use_Current_Location
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
        <Delete_Contact_Modal
          modal_title="Log Out"
          message="Are you sure, you want to Log Out?"
          show={showLogoutModal}
          onHide={() => setshowLogoutModal(false)}
          yesAction={() => setIsLogedIn(false)}
          noAction={() => setshowLogoutModal(false)}
        />
        <Login_Modal
          show={showLoginModal}
          onHide={() => setShowLoginModal(false)}
          loginDone={() => setIsLogedIn(true)}
          setShowResetModal={() => setShowResetModal(true)}
          setShowAccountCreted={() => setShowAccountCreted(true)}
        />
        <Reset_Password_Modal
          email={email}
          setEmail={setEmail}
          contact={contact}
          setContact={setContact}
          show={showResetModal}
          onHide={() => setShowResetModal(false)}
          setShowSetPassModal={() => setShowSetPassModal(true)}
        />
        <Set_New_Password_Modal
          email={email}
          setEmail={setEmail}
          contact={contact}
          setContact={setContact}
          show={showSetPassModal}
          onHide={() => setShowSetPassModal(false)}
        />
      </section>
    </>
  );
}

export default Header;
